// @flow

// Effect Manager
import { fork, put, take, select } from 'redux-saga/effects'

// Selectors
import orderTestsOperation$ from '../selectors/orderTestsOperation'
import { authenticatedUserId$ } from 'fc-authenticated-user'
import { userBillingInfo$ } from 'hfty-users'
import { currentUser$ } from 'hfty-users/src'

// Constants
import {
  PROP_USER_BILLING_INFO,
  PROP_ADDRESS,
  PROP_CITY,
  PROP_COUNTRY,
  PROP_PROVINCE,
  PROP_POSTAL_CODE,
  PROP_SHIPPING_PACKAGE_TYPE,
  BOX,
} from 'hfty-model-orders'

// Action Types
import { CREATE_TESTS_ORDER } from '../constants'

// Operator
import orderTestsOperator from 'hfty-operator-order-tests'

export default function *watchOrderTestsOperations (): Generator<*, void, *> {
  while (true) {
    const { payload, type } = yield take([CREATE_TESTS_ORDER])
    if (type === CREATE_TESTS_ORDER) {
      yield fork(handleCreateOrder, payload)
    }
  }
}

export function *handleCreateOrder (payload: Object): Generator<*, void, *> {
  const orderTestOperation = yield select(orderTestsOperation$)
  const { clientBillingAddress } = yield select(currentUser$)
  if (orderTestOperation) {
    const action = yield orderTestsOperator.actionCreators.cancelOperation(orderTestOperation)
    yield put(action)
  }

  const billingInfo = yield select(userBillingInfo$)
  const email = (billingInfo && billingInfo.email) || ''

  const operation = orderTestsOperator.create({
    model: {
      order: {
        address: '',
        city: '',
        province: '',
        postal_code: '',
        country: '',
        phone: '',
        email,
        preferred_contact: '',
        supplies: [],
        client: yield select(authenticatedUserId$),
        [PROP_SHIPPING_PACKAGE_TYPE]: BOX,
      },
      [PROP_USER_BILLING_INFO]: {
        [PROP_ADDRESS]: clientBillingAddress[PROP_ADDRESS],
        [PROP_CITY]: clientBillingAddress[PROP_CITY],
        [PROP_COUNTRY]: clientBillingAddress[PROP_COUNTRY],
        [PROP_PROVINCE]: clientBillingAddress[PROP_PROVINCE],
        [PROP_POSTAL_CODE]: clientBillingAddress[PROP_POSTAL_CODE],
      },
      jobs: [],
      isLoading: false,
    },
  })

  yield put(orderTestsOperator.actionCreators.add(operation))
}
